export function isOnboardingWizard() {
  return /.*\/restaurant\/.+\/onboarding\/.+/.test(window.location.pathname);
}
